import { ChartSummary } from './ChartSummary';
import { ChartWrapper } from './ChartWrapper';

export const Chart = {
  Wrapper: ChartWrapper,
  Summary: ChartSummary,
};
